import { MappingItem } from '../types'

const mapping: MappingItem[] = [
  { label: 'not-registered', value: 'SHOULD_BE_AND_EXCEEDED' },
  { label: 'should-be-registered', value: 'SHOULD_BE' },
]

export default mapping
